import { render, staticRenderFns } from "./WorkflowComponent.vue?vue&type=template&id=289f6b94&scoped=true&"
import script from "./WorkflowComponent.vue?vue&type=script&lang=js&"
export * from "./WorkflowComponent.vue?vue&type=script&lang=js&"
import style0 from "./WorkflowComponent.vue?vue&type=style&index=0&id=289f6b94&scoped=true&lang=scss&"
import style1 from "./WorkflowComponent.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "289f6b94",
  null
  
)

export default component.exports